export enum ServiceType {
  Assessments = 'Assessments',
  AssessmentsPA = 'AssessmentsPA',
  Growth = 'Growth',
  AssessmentService = 'AssessmentService',
  AdministrationService = 'AdministrationService',
  SchedulingService = 'SchedulingService',
  ObjectiveService = 'ObjectiveService',
  MapRatingService = 'MapRatingService',
  CommentService = 'CommentService',
  AttachmentService = 'AttachmentService',
  MapConfigurationService = 'MapConfigurationService',
  SkillsetService = 'SkillsetService'
}
